"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioPause = void 0;
var util_1 = require("./util");
var audioPause = function (event) {
    return (0, util_1.audioEvent)(event, "audio-pause");
};
exports.audioPause = audioPause;
